<template>
  <!-- ホーム画面 -->
  <div id="devToolHome">
    <div id="container">
      <div id="item-contens">
        <div class="card-content margin-top">
          <span class="notice">MOCK用 疑似Web連携API呼出し</span>
          <div style="text-align: left;margin-top:20px;font-size:20px;">【呼出しAPI】</div>
          <table>
            <tr>
              <th></th>
              <td>
                <b-select expanded size="is-medium" v-model="api">
                <option value="serialAlignment">シリアル連携</option>
                <option value="shipmentCompletedAlignment">出荷完了連携</option>
                <option value="machineReturned">機器返却連携</option>
                <option value="kanjaDotaiCreateRequest">患者動態作成依頼</option>
                <option value="serialExchange">シリアル変更連携(器械交換)</option>
                <option value="internalInstruction">内部指示書API</option>
              </b-select>
              </td>
            </tr>
          </table>
          <div style="text-align: left;margin-top:20px;font-size:20px;">【パラメータ】</div>
          <div align="center" style="margin-top:10px;">
            <table>
              <tr>
                <th>患者コード<span class="require" /></th>
                <td><b-input v-model="param.patientCode"/></td>
              </tr>
              <tr>
                <th>オーダーID（モック環境では、患者コードを指定）</th>
                <td><b-input v-model="param.orderId"/></td>
              </tr>
              <tr>
                <th>品目コード</th>
                <td><b-input v-model="param.itemCode"/></td>
              </tr>
              <tr>
                <th>シリアル></th>
                <td><b-input v-model="param.serial"/></td>
              </tr>
              <tr>
                <th>新シリアル(シリアル変更後)</th>
                <td><b-input v-model="param.newSerial"/></td>
              </tr>
              <tr>
                <th>オーダー明細番号(任意の値)</th>
                <td><b-input v-model="param.orderDetailsNumber"/></td>
              </tr>
              <tr>
                <th>新品目コード</th>
                <td><b-input v-model="param.newItemCode"/></td>
              </tr>
              <tr>
                <th>新品目シリアル</th>
                <td><b-input v-model="param.newSerial"/></td>
              </tr>
              <tr>
                <th>新オーダーID</th>
                <td><b-input v-model="param.newOrderId"/></td>
              </tr>
              <tr>
                <th>新オーダー明細</th>
                <td><b-input v-model="param.newOrderDetailsNumber"/></td>
              </tr>
              <tr>
                <th>定期交換フラグ</th>
                <td><b-input v-model="param.replacementFlg"/></td>
              </tr>
            </table>
            <div class="button-area">
              <b-button class="button is-primary" type="button" @click="mockApiCall()">呼出し</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";

export default {
  name: "devToolHome",
  methods: {
    mockApiCall: function() {
      var clientId = process.env.CLIENT_ID
      var clientSecret = process.env.CLIENT_SECRET
      var _this = this
      this.apiCall(
        function(client){
          return client.apis.WebSystem.apiToken({
            body:{
              clientId:clientId,
              clientSecret:clientSecret
            }
          });        
        },
        async function(result){
          _this.apiCall(
            function(client){
              return client.apis.WebSystem[_this.api]({
                body:_this.param
              });        
            },
            async function(result){
              _this.showSuccess(result);
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      notice: "",
      role: role,
      userInfo,
      api:"serialAlignment",
      param:{}
    };
  },
  components: {},
  mounted: async function(){}
};
</script>
<style lang="scss" scoped>
.notice {
  font-size: 25px;
}
.noticeTextArea {
  width: 100%;
  height: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/dev/devToolHome.vue